import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Edit2, ChevronUp, ChevronDown, FileText } from 'lucide-react';
interface ReviewSectionProps {
  id: string;
  title: string;
  icon: ComponentType<{
    className?: string;
  }>;
  status: string;
  content: string;
  legalExcerpt: string;
  isExpanded: boolean;
  onToggle: () => void;
  onEdit: () => void;
  onViewInDocument?: () => void;
  children?: React.ReactNode;
}
export function ReviewSection({
  id,
  title,
  icon: Icon,
  status,
  content,
  legalExcerpt,
  isExpanded,
  onToggle,
  onEdit,
  onViewInDocument,
  children
}: ReviewSectionProps) {
  return <div className={`bg-white rounded-xl border-[0.5px] shadow-sm overflow-hidden transition-all ${status === 'flagged' ? 'border-amber-300' : status === 'skipped' ? 'border-dashed border-borderColor opacity-70' : 'border-borderColor'}`} data-id="element-1161">
      <div className="p-4 sm:p-6 flex items-start justify-between group cursor-pointer hover:bg-aliceBlue/30 transition-colors" onClick={onToggle} data-id="element-1162">
        <div className="flex gap-3 sm:gap-4 w-full" data-id="element-1163">
          <div className={`p-2 sm:p-3 rounded-xl h-fit flex-shrink-0 ${status === 'flagged' ? 'bg-amber-50 text-amber-600' : status === 'skipped' ? 'bg-gray-100 text-secondary' : 'bg-aliceBlue text-violetBlue'}`} data-id="element-1164">
            <Icon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-1165" />
          </div>
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4" data-id="element-1166">
            <div data-id="element-1167">
              <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-1168">
                <h3 className="text-base sm:text-lg font-semibold text-primary" data-id="element-1169">
                  {title}
                </h3>
                {status === 'flagged' && <span className="px-2 py-0.5 bg-amber-100 text-amber-800 text-xs rounded-md font-medium" data-id="element-1170">
                    Needs Attention
                  </span>}
                {status === 'skipped' && <span className="px-2 py-0.5 bg-gray-100 text-secondary text-xs rounded-md font-medium" data-id="element-1171">
                    Skipped
                  </span>}
              </div>
              <p className="text-secondary whitespace-pre-line text-xs sm:text-sm" data-id="element-1172">
                {content}
              </p>
            </div>
            <div className="hidden md:block pl-4 border-l border-borderColor" data-id="element-1173">
              <p className="text-xs font-semibold text-secondary uppercase tracking-wider mb-1" data-id="element-1174">
                Legal Excerpt
              </p>
              <p className="font-serif text-xs text-gray-600 italic line-clamp-3" data-id="element-1175">
                "{legalExcerpt}"
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0 ml-2 sm:ml-4" data-id="element-1176">
          <button onClick={e => {
          e.stopPropagation();
          onEdit();
        }} className="text-violetBlue font-medium text-xs sm:text-sm flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity hover:underline" data-id="element-1177">
            <Edit2 className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-1178" />{' '}
            <span className="hidden sm:inline" data-id="element-1179">Edit</span>
          </button>
          {isExpanded ? <ChevronUp className="w-5 h-5 text-disabled" data-id="element-1180" /> : <ChevronDown className="w-5 h-5 text-disabled" data-id="element-1181" />}
        </div>
      </div>

      {/* Expanded Details */}
      <AnimatePresence data-id="element-1182">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="border-t border-borderColor bg-aliceBlue/30 p-4 sm:p-6" data-id="element-1183">
            {children}

            <div className="bg-white p-4 sm:p-6 border border-borderColor rounded-lg shadow-sm" data-id="element-1184">
              <h4 className="text-xs sm:text-sm font-bold uppercase tracking-wider text-primary mb-4" data-id="element-1185">
                Full Legal Clause
              </h4>
              <div className="font-serif text-gray-800 text-xs sm:text-sm leading-relaxed" data-id="element-1186">
                {legalExcerpt}
              </div>
              {onViewInDocument && <button onClick={onViewInDocument} className="mt-4 text-xs sm:text-sm text-violetBlue font-medium hover:underline flex items-center gap-1" data-id="element-1187">
                  <FileText className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-1188" /> View in
                  document
                </button>}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}